(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    var panel = drawer.querySelector('.cd-panel') || drawer;
    var errorEl = drawer.querySelector('[data-cd-error]');
    var hideTimer = null;
    var lastFocus = null;
    var FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

    function focusable() {
      return Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), function (el) {
        return el.offsetWidth > 0 || el.offsetHeight > 0;
      });
    }
    function trap(e) {
      if (e.key !== 'Tab') return;
      var items = focusable();
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg || 'Der Warenkorb konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.';
      errorEl.hidden = false;
    }
    function clearError() { if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; } }
    // Shopify answers 4xx with {status, message, description}; surface the description.
    function checkOk(r) {
      if (r.ok) return r;
      return r.json().catch(function () { return {}; }).then(function (d) {
        var err = new Error((d && d.description) || (d && d.message) || 'cart request failed');
        err.userMessage = (d && d.description) || '';
        throw err;
      });
    }

    function setOpen(open) {
      clearTimeout(hideTimer);
      if (open) {
        if (!drawer.hidden && drawer.classList.contains('open')) return;
        lastFocus = document.activeElement;
        drawer.hidden = false;
        void drawer.offsetHeight; // flush display:none → block before transition
        requestAnimationFrame(function () { drawer.classList.add('open'); });
        var closeBtn = drawer.querySelector('.js-cd-close');
        if (closeBtn) closeBtn.focus();
        panel.addEventListener('keydown', trap);
      } else {
        drawer.classList.remove('open');
        panel.removeEventListener('keydown', trap);
        clearError();
        hideTimer = setTimeout(function () { drawer.hidden = true; }, 300);
        if (lastFocus && lastFocus.focus && drawer.contains(document.activeElement)) lastFocus.focus();
        lastFocus = null;
      }
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (!open && drawer.dataset.dirty === '1' && document.querySelector('.cartp')) { drawer.dataset.dirty = ''; window.location.reload(); }
    }

    var body = document.getElementById('cart-drawer-body');
    var fmt;
    try { fmt = new Intl.NumberFormat(body.dataset.locale || 'de', { style: 'currency', currency: body.dataset.currency || 'EUR' }); }
    catch (e) { fmt = { format: function (n) { return n.toFixed(2).replace('.', ',') + ' €'; } }; }
    function money(cents) { return fmt.format(cents / 100); }
    function esc(str) { return String(str).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function imgUrl(url, w) { if (!url) return ''; return url.replace(/(\.[a-z]+)(\?.*)?$/i, '_' + w + 'x$1$2'); }

    var TRASH = document.getElementById('cd-ic-trash').innerHTML;
    var DIAMOND = document.getElementById('cd-ic-diamond').innerHTML;
    var CHECK = document.getElementById('cd-ic-check').innerHTML;
    var headSub = drawer.querySelector('[data-cd-sub]');

    function render(cart) {
      document.dispatchEvent(new CustomEvent('hv:cart:updated', { detail: cart }));
      if (headSub) {
        var note = headSub.dataset.note || '';
        headSub.textContent = cart.item_count + ' Artikel' + (note ? ' · ' + note : '');
        headSub.hidden = !cart.item_count;
      }
      if (!cart.items.length) {
        body.innerHTML = '';
        body.appendChild(document.getElementById('cd-empty-tpl').content.cloneNode(true));
        return;
      }
      var isBread = function (it) { return /brot/i.test(it.handle || '') || /brot/i.test(it.product_title || ''); };
      var linked = function (it) { return (it.line_level_discount_allocations || []).length > 0; };
      var saveOf = function (it) { return (it.line_level_discount_allocations || []).reduce(function (a, d) { return a + d.amount; }, 0); };
      var bundledBread = cart.items.some(function (it) { return isBread(it) && saveOf(it) > 0; });
      var html = '<div class="cd-scroll"><div class="cd-items">';
      cart.items.forEach(function (it, i) {
        var line = i + 1;
        var title = it.product_title + (it.variant_title && it.variant_title !== 'Default Title' ? ' · ' + it.variant_title : '');
        var bread = isBread(it);
        var saved = saveOf(it);
        var meta = '';
        if (bread && saved > 0) meta = '<span class="cd-bundle">' + DIAMOND + 'Bundle-Vorteil &ndash; ' + money(saved) + '</span>';
        else if (!bread && bundledBread && linked(it)) meta = '<span class="cd-bundle-note">+ Dosenbrot im Bundle</span>';
        var price = saved > 0
          ? '<span class="cd-item-price"><s>' + money(it.original_line_price) + '</s> <b>' + money(it.final_line_price) + '</b></span>'
          : '<b class="cd-item-price">' + money(it.final_line_price) + '</b>';
        var qtyCtl = '<span class="stepper stepper--sm">' +
            '<button type="button" class="js-cd-qty" data-line="' + line + '" data-qty="' + (it.quantity - 1) + '" aria-label="Weniger">&minus;</button>' +
            '<b>' + it.quantity + '</b>' +
            '<button type="button" class="js-cd-qty" data-line="' + line + '" data-qty="' + (it.quantity + 1) + '" aria-label="Mehr">+</button></span>';
        html += '<div class="cd-item' + (saved > 0 ? ' cd-item--bundle' : '') + '" data-line="' + line + '">' +
          '<a href="' + esc(it.url) + '" class="cd-item-img">' + (it.image ? '<img src="' + esc(imgUrl(it.image, 160)) + '" alt="' + esc(it.product_title) + '" width="80" height="80" loading="lazy">' : '') + '</a>' +
          '<div class="cd-item-main"><div class="cd-item-top"><a href="' + esc(it.url) + '"><b>' + esc(title) + '</b></a>' +
          '<button type="button" class="cd-remove js-cd-qty" data-qty="0" data-line="' + line + '" aria-label="Entfernen">' + TRASH + '</button></div>' +
          (meta ? '<div class="cd-item-meta">' + meta + '</div>' : '') +
          '<div class="cd-item-row">' + qtyCtl + price + '</div></div></div>';
      });
      html += '</div></div>';
      body.innerHTML = html;
      var summary = document.getElementById('cd-foot-tpl').content.cloneNode(true);
      summary.querySelector('[data-subtotal]').textContent = money(cart.items_subtotal_price);
      if (cart.total_discount > 0) {
        var save = document.createElement('div'); save.className = 'cd-saved';
        save.innerHTML = '<span>Bundle-Rabatt</span><b>&minus;' + money(cart.total_discount) + '</b>';
        summary.querySelector('.cd-sum-rows').appendChild(save);
      }
      var scroll = body.querySelector('.cd-scroll');
      ['cd-trust-tpl', 'cd-gift-tpl', 'cd-upsell-tpl'].forEach(function (id) {
        var tpl = document.getElementById(id);
        if (tpl && tpl.content.children.length) scroll.appendChild(tpl.content.cloneNode(true));
      });
      scroll.appendChild(summary);
      var bar = document.getElementById('cd-bar-tpl').content.cloneNode(true);
      bar.querySelector('[data-total]').textContent = money(cart.total_price);
      body.appendChild(bar);
    }



    function fetchCart() {
      return fetch('/cart.js?_=' + Date.now(), { cache: 'no-store', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    }

    function refresh() {
      drawer.classList.add('is-loading');
      return fetchCart()
        .then(function (cart) { render(cart); return cart; })
        .then(updateBadge)
        .finally(function () { drawer.classList.remove('is-loading'); });
    }

    function updateBadge(c) {
      return Promise.resolve(c || fetchCart()).then(function (c) {
        var cartLink = document.querySelector('.nav-cart');
        if (!cartLink) return;
        var badge = cartLink.querySelector('.cart-badge');
        if (c.item_count > 0) {
          if (!badge) { badge = document.createElement('span'); badge.className = 'cart-badge'; cartLink.appendChild(badge); }
          badge.textContent = c.item_count;
        } else if (badge) { badge.remove(); }
      });
    }

    window.hvCart = {
      open: function () { return refresh().then(function () { setOpen(true); }); },
      close: function () { setOpen(false); },
      refresh: refresh,
      add: function (items) {
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () { return window.hvCart.open(); });
      }
    };

    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) setOpen(false);
      var close = e.target.closest('.js-cd-close');
      if (close) setOpen(false);
      var add = e.target.closest('.js-cd-add');
      if (add && add.dataset.id) {
        add.disabled = true;
        drawer.classList.add('is-loading');
        clearError();
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(add.dataset.id, 10), quantity: 1 }] }) })
          .then(checkOk)
          .then(function () { drawer.dataset.dirty = '1'; return refresh(); })
          .catch(function (err) { add.disabled = false; drawer.classList.remove('is-loading'); showError(err && err.userMessage); });
      }
      var q = e.target.closest('.js-cd-qty');
      if (q) {
        drawer.classList.add('is-loading');
        clearError();
        var line = parseInt(q.dataset.line, 10);
        var qty = Math.max(0, parseInt(q.dataset.qty, 10));
        var isBread = function (it) { return /brot/i.test(it.handle || '') || /brot/i.test(it.product_title || ''); };
        var linked = function (it) { return (it.line_level_discount_allocations || []).length > 0; };
        var post = function (updates) {
          return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) }).then(checkOk).then(function (r) { return r.json(); });
        };
        fetchCart()
          .then(function (cart) {
            var arr = cart.items.map(function (it) { return it.quantity; });
            var i = line - 1;
            if (!cart.items[i]) return cart;
            var delta = qty - arr[i];
            arr[i] = qty;
            // A bundle-linked package moves its bread with it
            if (delta !== 0 && linked(cart.items[i]) && !isBread(cart.items[i])) {
              var bi = -1;
              cart.items.forEach(function (it, j) { if (isBread(it) && (bi < 0 || linked(it))) bi = j; });
              if (bi >= 0) arr[bi] = Math.max(0, arr[bi] + delta);
            }
            return post(arr);
          })
          .then(function (cart) {
            var packages = cart.items.filter(function (it) { return !isBread(it); });
            var breads = cart.items.filter(function (it) { return isBread(it) && linked(it); });
            if (!packages.length && breads.length) return post(cart.items.map(function (it) { return isBread(it) ? 0 : it.quantity; }));
            return cart;
          })
          .then(function (cart) { drawer.dataset.dirty = '1'; render(cart); return updateBadge(cart); })
          .catch(function (err) { showError(err && err.userMessage); })
          .finally(function () { drawer.classList.remove('is-loading'); });
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) setOpen(false); });

    // Header cart icon opens the drawer; if the cart request fails, fall through to the cart page.
    document.querySelectorAll('.nav-cart').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        window.hvCart.open().catch(function () { window.location.href = a.href; });
      });
    });

    // Every product form adds via AJAX and opens the drawer
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement) || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
      if (form.dataset.hvNoDrawer !== undefined || e.defaultPrevented) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var label = btn ? btn.innerHTML : '';
      if (btn) { btn.classList.add('is-loading'); btn.innerHTML = 'Wird hinzugefügt…'; }
      var fd = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); })
        .then(function () {
          if (btn) { btn.classList.remove('is-loading'); btn.classList.add('is-done'); btn.innerHTML = CHECK + ' Im Warenkorb'; }
          return window.hvCart.open();
        })
        .then(function () { setTimeout(function () { if (btn) { btn.classList.remove('is-done'); btn.innerHTML = label; } }, 1200); })
        .catch(function () { if (btn) { btn.classList.remove('is-loading'); btn.innerHTML = label; } form.dataset.hvNoDrawer = ''; form.submit(); });
    });
  })();

  // Harmonised legal guarantee notice: show the full-size notice in a modal.
  (function () {
    var modal = document.getElementById('legal-guarantee-modal');
    if (!modal) return;
    var lastFocus = null;

    function close() {
      if (modal.hidden) return;
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      lastFocus = null;
    }

    function open(trigger) {
      lastFocus = trigger || document.activeElement;
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      var closeBtn = modal.querySelector('.js-lgn-close');
      if (closeBtn) closeBtn.focus();
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest ? e.target.closest('.js-lgn-open') : null;
      if (trigger) { e.preventDefault(); open(trigger); return; }
      if (e.target.closest && e.target.closest('.js-lgn-close')) { e.preventDefault(); close(); return; }
      if (e.target === modal) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.cartp').forEach(function (root) {
    root.classList.add('js-on');
    var isBread = function (it) { return /brot/i.test(it.handle || '') || /brot/i.test(it.product_title || ''); };
    var linked = function (it) { return (it.line_level_discount_allocations || []).length > 0; };
    var errorEl = root.querySelector('[data-cart-error]');
    function post(updates) {
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) })
        .then(function (r) {
          if (r.ok) return r.json();
          // Shopify answers 4xx with {status, message, description}
          return r.json().catch(function () { return {}; }).then(function (d) {
            var err = new Error((d && d.description) || 'cart update failed');
            err.userMessage = (d && d.description) || '';
            throw err;
          });
        });
    }
    // Per-line change (lines are 1-based, matching Shopify's cart order). A bundle-linked package moves its bread with it.
    function change(line, qty) {
      root.classList.add('is-loading');
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      return fetch('/cart.js?_=' + Date.now(), { cache: 'no-store' }).then(function (r) { return r.json(); })
        .then(function (cart) {
          var arr = cart.items.map(function (it) { return it.quantity; });
          var i = line - 1;
          if (!cart.items[i]) return cart;
          var delta = qty - arr[i];
          arr[i] = qty;
          if (delta !== 0 && linked(cart.items[i]) && !isBread(cart.items[i])) {
            var bi = -1;
            cart.items.forEach(function (it, j) { if (isBread(it) && (bi < 0 || linked(it))) bi = j; });
            if (bi >= 0) arr[bi] = Math.max(0, arr[bi] + delta);
          }
          return post(arr);
        })
        .then(function (cart) {
          var packages = cart.items.filter(function (it) { return !isBread(it); });
          var breads = cart.items.filter(function (it) { return isBread(it) && linked(it); });
          if (!packages.length && breads.length) return post(cart.items.map(function (it) { return isBread(it) ? 0 : it.quantity; }));
          return cart;
        })
        .then(function () { window.location.reload(); })
        .catch(function (err) {
          root.classList.remove('is-loading');
          if (errorEl) {
            errorEl.textContent = (err && err.userMessage) || 'Der Warenkorb konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.';
            errorEl.hidden = false;
          }
        });
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('.js-cart-qty');
      if (!b) return;
      e.preventDefault();
      change(parseInt(b.dataset.line, 10), Math.max(0, parseInt(b.dataset.qty, 10)));
    });
    root.querySelectorAll('.cartp-qty').forEach(function (inp) {
      inp.addEventListener('change', function () {
        change(parseInt(inp.dataset.line, 10), Math.max(0, parseInt(inp.value, 10) || 0));
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.querySelectorAll('.pkg').forEach(function (root) {
    var toggle = root.querySelector('.pkg-toggle');
    var grid = root.querySelector('[data-cards]');
    if (!toggle || !grid) return;

    var cards = Array.prototype.slice.call(root.querySelectorAll('.pkg-card'));
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var DURATION = 180;
    var busy = false;

    function apply(diet) {
      cards.forEach(function (c) { c.hidden = c.dataset.diet !== diet; });
    }

    toggle.querySelectorAll('button[data-diet]').forEach(function (b) {
      b.addEventListener('click', function () {
        var diet = b.dataset.diet;
        if (busy || b.classList.contains('active')) return;

        toggle.querySelectorAll('button').forEach(function (x) { x.classList.toggle('active', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });

        if (reduce) { apply(diet); return; }

        // Hold the current height so the swap does not jolt the page.
        busy = true;
        grid.style.minHeight = grid.offsetHeight + 'px';
        grid.classList.add('is-swapping');
        window.setTimeout(function () {
          apply(diet);
          grid.classList.remove('is-swapping');
          window.setTimeout(function () {
            grid.style.minHeight = '';
            busy = false;
          }, DURATION);
        }, DURATION);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-cookie-preferences]');
    if (!link || typeof window.privacyBanner?.showPreferences !== 'function') return;
    event.preventDefault();
    window.privacyBanner.showPreferences();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var burger = document.getElementById('vh-burger');
    var closeBtn = document.getElementById('vh-burger-close');
    var nav = document.getElementById('vh-mobile-nav');
    var panel = document.getElementById('vh-mobile-nav-panel');
    if (burger && nav && panel) {
      var FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';
      var scrollY = 0;
      var hideTimer = null;

      var focusable = function () {
        return Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), function (el) {
          return el.offsetWidth > 0 || el.offsetHeight > 0;
        });
      };

      var trap = function (e) {
        if (e.key !== 'Tab') return;
        var items = focusable();
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      };

      var setOpen = function (open) {
        clearTimeout(hideTimer);
        if (open) {
          scrollY = window.scrollY;
          nav.hidden = false;
          void nav.offsetHeight;
          requestAnimationFrame(function () { nav.classList.add('open'); });
          (closeBtn || panel).focus();
          panel.addEventListener('keydown', trap);
          document.body.style.position = 'fixed';
          document.body.style.top = -scrollY + 'px';
          document.body.style.width = '100%';
          document.documentElement.style.overflow = 'hidden';
        } else {
          nav.classList.remove('open');
          panel.removeEventListener('keydown', trap);
          hideTimer = setTimeout(function () { nav.hidden = true; }, 220);
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.width = '';
          document.documentElement.style.overflow = '';
          window.scrollTo(0, scrollY);
          if (document.activeElement === document.body) burger.focus();
        }
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      };

      burger.addEventListener('click', function () { setOpen(!nav.classList.contains('open')); });
      if (closeBtn) closeBtn.addEventListener('click', function () { burger.focus(); setOpen(false); });
      nav.addEventListener('click', function (e) { if (e.target === nav) { burger.focus(); setOpen(false); } });
      nav.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { setOpen(false); }); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !nav.hidden) { burger.focus(); setOpen(false); }
      });
    }

    var navCta = document.querySelector('.nav-cta');
    var revealNavCta = function () {
      if (!navCta || !document.querySelector('.hero')) return;
      var onCtaScroll = function () {
        document.body.toggleAttribute('data-scrolled', window.scrollY > 600);
      };
      window.addEventListener('scroll', onCtaScroll, { passive: true });
      onCtaScroll();
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', revealNavCta);
    } else {
      revealNavCta();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  // Promo tag CTA: keep people on the page - scroll to the signup form and
  // put the cursor straight in the email field.
  document.addEventListener('click', function (e) {
    var cta = e.target.closest && e.target.closest('.hero-promo-cta');
    if (!cta) return;
    var hash = (cta.getAttribute('href') || '').split('#')[1];
    if (!hash) return;
    var target = document.getElementById(hash);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var field = target.querySelector('input[type="email"]');
    if (field) setTimeout(function () { field.focus({ preventScroll: true }); }, 500);
  });

  // Pendulum for the hanging promo tag: scrolling and slide changes push it,
  // a spring pulls it back. Runs only while the hero is on screen.
  function initPromoSwing(hero) {
    var el = hero.querySelector('.hero-promo-swing');
    if (!el || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return null;
    // The tag only renders from 1360px up (see stylesheet); below that it is display:none and nothing needs animating.
    if (!window.matchMedia('(min-width: 1360px)').matches) return null;

    var STIFF = 0.0062, DAMP = 0.055, MAX = 9;
    var angle = 0, vel = 0, push = 0, lastY = window.scrollY, raf = null, visible = false, active = false, t0 = 0;

    var step = function (t) {
      // Hand over from the CSS fallback only once a frame has actually run, so
      // a throttled rAF leaves the card swaying rather than frozen.
      if (!t0) { t0 = t; el.style.animation = 'none'; }
      push += Math.sin((t - t0) / 900) * 0.0018;          // never settles completely
      vel += -STIFF * angle - DAMP * vel + push;
      push = 0;
      angle += vel;
      if (angle > MAX) { angle = MAX; vel *= -0.4; }
      if (angle < -MAX) { angle = -MAX; vel *= -0.4; }
      el.style.setProperty('--swing', angle.toFixed(3) + 'deg');
      raf = (visible && active) ? requestAnimationFrame(step) : null;
    };
    var start = function () { if (!raf && visible && active) raf = requestAnimationFrame(step); };
    var stop = function () { if (raf) { cancelAnimationFrame(raf); raf = null; } };

    window.addEventListener('scroll', function () {
      var y = window.scrollY, d = y - lastY;
      lastY = y;
      push += Math.max(-0.28, Math.min(0.28, d * 0.0016));
      start();
    }, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) start(); else stop();
      }, { threshold: 0 }).observe(hero);
    } else { visible = true; start(); }

    return {
      kick: function (amount) { push += amount; start(); },
      // Only the intro slide shows the tag; the loop idles while the offer slide is up.
      setActive: function (on) { active = !!on; if (active) start(); else stop(); }
    };
  }

  document.querySelectorAll('.hero').forEach(function (hero) {
    // Phones render only the offer slide (see stylesheet), so no pendulum, timer, dots or swipe handling there.
    var isPhone = window.matchMedia('(max-width: 899px)').matches;
    var swing = isPhone ? null : initPromoSwing(hero);
    var slide = parseInt(hero.dataset.start, 10) || 0;
    var auto = parseInt(hero.dataset.auto, 10) || 0;
    var wheel = hero.dataset.wheel === 'true';
    var timer = null, cool = 0;
    var set = function (i) {
      slide = i;
      hero.dataset.slide = String(i);
      if (swing) swing.setActive(i === 1);
      // Let the slide transition land first, then shove the tag hard.
      if (i === 1 && swing) setTimeout(function () { swing.kick(0.78); }, 470);
    };
    var stopAuto = function () { clearTimeout(timer); timer = null; hero.removeAttribute('data-auto-running'); };
    // Auto-advance cycles between both slides until the user interacts.
    var armAuto = function () {
      clearTimeout(timer);
      hero.removeAttribute('data-auto-running');
      void hero.offsetWidth; // restart the progress animation
      hero.setAttribute('data-auto-running', '1');
      timer = setTimeout(function () { set(slide === 0 ? 1 : 0); armAuto(); }, auto * 1000);
    };
    if (isPhone) { hero.dataset.slide = '0'; return; }
    set(slide);
    if (auto > 0) {
      hero.style.setProperty('--auto-ms', (auto * 1000) + 'ms');
      armAuto();
    }
    hero.querySelectorAll('.hero-dots button').forEach(function (b) {
      b.addEventListener('click', function () { stopAuto(); set(parseInt(b.dataset.go, 10)); });
    });
    if (wheel) {
      hero.addEventListener('wheel', function (e) {
        var now = Date.now();
        if (cool && now - cool < 950) { e.preventDefault(); return; }
        var r = hero.getBoundingClientRect();
        if (slide === 0 && e.deltaY > 8 && r.top > -60) {
          e.preventDefault(); cool = now; stopAuto(); set(1);
        } else if (slide === 1 && e.deltaY < -8 && window.scrollY <= 2 && r.top > -60) {
          e.preventDefault(); cool = now; set(0);
        }
      }, { passive: false });
    }
    var x0 = null;
    hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) < 50) return;
      stopAuto(); set(dx < 0 ? 1 : 0);
    }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-products"] && !Shopify.designMode) return;
  try {
    
  function initCalculator(root) {
    var fmt = function (n) { return n.toLocaleString('de-DE'); };
    var cartUrl = root.getAttribute('data-cart-url') || '/cart';
    var prices = {
      m30: parseInt(root.getAttribute('data-price-30-meat'), 10) || 0,
      v30: parseInt(root.getAttribute('data-price-30-vegan'), 10) || 0,
      m10: parseInt(root.getAttribute('data-price-10-meat'), 10) || 0,
      v10: parseInt(root.getAttribute('data-price-10-vegan'), 10) || 0
    };
    var currency = root.getAttribute('data-currency') || 'EUR';
    var money = function (cents) {
      try { return new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency }).format(cents / 100); }
      catch (e) { return (cents / 100).toLocaleString('de-DE') + ' €'; }
    };
    var K30m = parseInt(root.getAttribute('data-kcal30-meat'), 10) || 0;
    var K10m = parseInt(root.getAttribute('data-kcal10-meat'), 10) || 0;
    var K30v = parseInt(root.getAttribute('data-kcal30-vegan'), 10) || 0;
    var K10v = parseInt(root.getAttribute('data-kcal10-vegan'), 10) || 0;
    var labelPkg30 = root.getAttribute('data-label-pkg30') || '';
    var labelPkg10 = root.getAttribute('data-label-pkg10') || '';
    var labelMeat = root.getAttribute('data-label-meat') || 'Fleisch';
    var labelVegan = root.getAttribute('data-label-vegan') || 'Vegetarisch';
    var vids = {
      m30: root.getAttribute('data-vid-30-meat'), v30: root.getAttribute('data-vid-30-vegan'),
      m10: root.getAttribute('data-vid-10-meat'), v10: root.getAttribute('data-vid-10-vegan')
    };

    var modal = root.querySelector('.js-calc-modal');
    var openBtn = root.querySelector('.js-calc-open');
    var closeBtn = root.querySelector('.js-calc-close');
    var persInput = root.querySelector('.js-persons');
    var persMinus = root.querySelector('.js-pers-minus');
    var persPlus = root.querySelector('.js-pers-plus');
    var dayChips = root.querySelector('.js-day-chips');
    var dayOther = root.querySelector('.js-day-other');
    var daysFree = root.querySelector('.js-days-free');
    var freeRows = root.querySelectorAll('.js-days-free-row');
    var variantSeg = root.querySelector('.js-variant-seg');
    var breakdown = root.querySelector('.js-breakdown');
    var elPersDays = root.querySelector('.js-persondays');
    var elPrice = root.querySelector('.js-price');
    var elKcal = root.querySelector('.js-kcal');
    var addBtn = root.querySelector('.js-add-to-cart');

    var state = { persons: 2, days: 30, variant: 'gemischt', other: false };

    if (openBtn && modal) {
      openBtn.addEventListener('click', function () { modal.showModal(); });
      closeBtn.addEventListener('click', function () { modal.close(); });
      modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });
      document.querySelectorAll('a[href="#' + (root.getAttribute('data-calc-anchor') || 'rechner') + '"]').forEach(function (a) {
        a.addEventListener('click', function (e) { e.preventDefault(); modal.showModal(); });
      });
    }

    function computePackages(personDays) {
      var pkg30 = Math.floor(personDays / 30);
      var remainder = personDays - pkg30 * 30;
      var pkg10 = remainder > 0 ? Math.ceil(remainder / 10) : 0;
      return { pkg30: pkg30, pkg10: pkg10 };
    }
    function splitMeatVegan(count) { var meat = Math.ceil(count / 2); return { meat: meat, vegan: count - meat }; }
    function splitFor(count) {
      if (state.variant === 'fleisch') return { meat: count, vegan: 0 };
      if (state.variant === 'vegan') return { meat: 0, vegan: count };
      return splitMeatVegan(count);
    }
    function lastResult() {
      var persons = Math.max(1, state.persons || 1);
      var days = Math.max(1, state.days || 1);
      var pd = persons * days;
      var p = computePackages(pd);
      return { personDays: pd, pkg30: p.pkg30, pkg10: p.pkg10 };
    }
    function line(n, label, split, small) {
      var pills = '';
      if (split.meat > 0) pills += '<span class="pkg-pill">' + split.meat + ' × ' + labelMeat + '</span>';
      if (split.vegan > 0) pills += '<span class="pkg-pill vegan">' + split.vegan + ' × ' + labelVegan + '</span>';
      return '<div class="pkg-line' + (small ? ' small' : '') + '"><span class="pkg-num">' + n + '</span><span class="pkg-name">&nbsp;' + label + '</span>' +
        (pills ? '<span class="pkg-pills">' + pills + '</span>' : '') + '</div>';
    }
    function render() {
      var r = lastResult();
      var s30 = splitFor(r.pkg30), s10 = splitFor(r.pkg10);
      var html = '';
      if (r.pkg30 > 0) html += line(r.pkg30, labelPkg30, s30, false);
      if (r.pkg10 > 0) html += line(r.pkg10, labelPkg10, s10, r.pkg30 > 0);
      if (!html) html = line(0, labelPkg30, { meat: 0, vegan: 0 }, false);
      breakdown.innerHTML = html;
      elPersDays.textContent = fmt(r.personDays);
      var total = r.pkg30 + r.pkg10;
      var cents = s30.meat * prices.m30 + s30.vegan * prices.v30 + s10.meat * prices.m10 + s10.vegan * prices.v10;
      var kcal = s30.meat * K30m + s30.vegan * K30v + s10.meat * K10m + s10.vegan * K10v;
      elPrice.textContent = total > 0 ? money(cents) : '–';
      elKcal.textContent = total > 0 ? fmt(kcal) + ' kcal' : '–';
    }

    function setPersons(v) { state.persons = Math.min(50, Math.max(1, v || 1)); persInput.value = state.persons; render(); }
    persMinus.addEventListener('click', function () { setPersons(state.persons - 1); });
    persPlus.addEventListener('click', function () { setPersons(state.persons + 1); });
    persInput.addEventListener('input', function () { setPersons(parseInt(persInput.value, 10)); });

    function setOther(on) {
      state.other = on;
      freeRows.forEach(function (el) { el.hidden = !on; });
      dayOther.classList.toggle('active', on);
      if (on) {
        dayChips.querySelectorAll('.chip-day').forEach(function (c) { c.classList.remove('active'); });
        state.days = Math.max(1, parseInt(daysFree.value, 10) || 1);
        render();
      }
    }
    function setDays(v) {
      state.days = Math.min(3650, Math.max(1, v || 1));
      dayChips.querySelectorAll('.chip-day').forEach(function (c) {
        c.classList.toggle('active', parseInt(c.dataset.days, 10) === state.days);
      });
      render();
    }
    dayChips.querySelectorAll('.chip-day').forEach(function (chip) {
      chip.addEventListener('click', function () { setOther(false); setDays(parseInt(chip.dataset.days, 10)); });
    });
    dayOther.addEventListener('click', function () { setOther(true); });
    daysFree.addEventListener('input', function () {
      var v = parseInt(daysFree.value, 10);
      if (!isNaN(v)) { state.days = Math.min(3650, Math.max(1, v)); render(); }
    });

    variantSeg.querySelectorAll('.seg').forEach(function (seg) {
      seg.addEventListener('click', function () {
        variantSeg.querySelectorAll('.seg').forEach(function (s) { s.classList.remove('active'); });
        seg.classList.add('active');
        state.variant = seg.dataset.variant;
        render();
      });
    });

    function buildItems() {
      var r = lastResult();
      var s30 = splitFor(r.pkg30), s10 = splitFor(r.pkg10);
      var items = [];
      function push(id, qty) { if (id && qty > 0) items.push({ id: parseInt(id, 10), quantity: qty }); }
      push(vids.m30, s30.meat); push(vids.v30, s30.vegan); push(vids.m10, s10.meat); push(vids.v10, s10.vegan);
      return items;
    }
    addBtn.addEventListener('click', function (e) {
      var items = buildItems();
      if (!items.length) return;
      e.preventDefault();
      addBtn.style.pointerEvents = 'none';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); })
        .then(function () { if (window.hvCart) { addBtn.style.pointerEvents = ''; if (modal) modal.close(); return window.hvCart.open(); } window.location.href = cartUrl; })
        .catch(function () { addBtn.style.pointerEvents = ''; window.location.href = cartUrl; });
    });

    render();
  }
  document.querySelectorAll('.calculator').forEach(initCalculator);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-legal"]) return;
  try {
    
  (function () {
    var MIN_HEADINGS = 3;

    function slugify(text, index) {
      var slug = text
        .toLowerCase()
        .replace(/ä/g, 'ae')
        .replace(/ö/g, 'oe')
        .replace(/ü/g, 'ue')
        .replace(/ß/g, 'ss')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
      return (slug || 'abschnitt') + '-' + index;
    }

    document.querySelectorAll('.legal').forEach(function (root) {
      var toc = root.querySelector('[data-legal-toc]');
      var content = root.querySelector('[data-legal-content]');
      if (!toc || !content) return;

      var headings = Array.prototype.slice.call(content.querySelectorAll('h2'));
      if (headings.length < MIN_HEADINGS) return;

      var list = toc.querySelector('[data-legal-toc-list]');
      var links = {};

      headings.forEach(function (heading, index) {
        if (!heading.id) {
          heading.id = slugify(heading.textContent || '', index + 1);
        }
        var item = document.createElement('li');
        var link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = (heading.textContent || '').trim();
        item.appendChild(link);
        list.appendChild(item);
        links[heading.id] = link;
      });

      toc.removeAttribute('hidden');

      if (!('IntersectionObserver' in window)) return;

      var visible = [];
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var id = entry.target.id;
            var at = visible.indexOf(id);
            if (entry.isIntersecting && at === -1) {
              visible.push(id);
            } else if (!entry.isIntersecting && at !== -1) {
              visible.splice(at, 1);
            }
          });

          var activeId = null;
          headings.forEach(function (heading) {
            if (visible.indexOf(heading.id) !== -1 && activeId === null) {
              activeId = heading.id;
            }
          });

          Object.keys(links).forEach(function (id) {
            if (id === activeId) {
              links[id].setAttribute('aria-current', 'true');
            } else {
              links[id].removeAttribute('aria-current');
            }
          });
        },
        { rootMargin: '-100px 0px -70% 0px' }
      );

      headings.forEach(function (heading) {
        observer.observe(heading);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  (function () {
    var root = document.querySelector('.nlp');
    if (!root) return;
    var DONE_KEY = 'hv-nl-subscribed', SHOWN_KEY = 'hv-nl-shown-at';
    var days = parseInt(root.dataset.days, 10) || 30;
    var inEditor = !!(window.Shopify && window.Shopify.designMode);
    var opened = false;

    function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
    function set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

    function open() {
      if (opened) return;
      var drawer = document.getElementById('cart-drawer');
      if (drawer && !drawer.hidden) return; // never over the cart
      var buying = null;
      try { buying = sessionStorage.getItem('hv-atc'); } catch (e) {}
      if (buying === '1') return; // user is buying, leave them alone
      opened = true;
      root.hidden = false;
      set(SHOWN_KEY, String(Date.now()));
      var inp = root.querySelector('.nlp-input');
      if (inp) setTimeout(function () { inp.focus(); }, 300);
    }
    function close() { root.hidden = true; }

    root.querySelectorAll('[data-nl-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });

    // Remember add-to-cart for this session so the popup doesn't interrupt a purchase
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (f instanceof HTMLFormElement && /\/cart\/add/.test(f.getAttribute('action') || '')) { try { sessionStorage.setItem('hv-atc', '1'); } catch (x) {} }
    }, true);

    if (root.querySelector('[data-nl-success]')) { set(DONE_KEY, '1'); root.hidden = false; return; }
    if (root.querySelector('.nlp-error')) { root.hidden = false; return; }
    if (inEditor || get(DONE_KEY) === '1') return;
    var last = parseInt(get(SHOWN_KEY) || '0', 10);
    if (last && Date.now() - last < days * 864e5) return;

    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (canHover && root.dataset.exitIntent === 'true') {
      var armed = false;
      setTimeout(function () { armed = true; }, 4000);
      document.addEventListener('mouseout', function (e) {
        if (!armed || e.relatedTarget || e.toElement) return;
        if (e.clientY <= 0) open();
      });
    } else {
      var pct = parseInt(root.dataset.mobileScroll, 10) || 50;
      var delay = (parseInt(root.dataset.mobileDelay, 10) || 25) * 1000;
      var onScroll = function () {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        if (max > 0 && window.scrollY / max * 100 >= pct) { window.removeEventListener('scroll', onScroll); open(); }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      setTimeout(open, delay);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var nav = root.querySelector('.pdet-nav');
      if (!nav || nav.dataset.pdetReady) return;
      nav.dataset.pdetReady = '1';
      var tabs = Array.prototype.slice.call(nav.querySelectorAll('.pdet-tab'));

      function select(i) {
        tabs.forEach(function (tab, idx) {
          var panel = root.querySelector('#' + tab.getAttribute('aria-controls'));
          var on = idx === i;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          if (panel) {
            panel.classList.toggle('is-active', on);
            panel.hidden = !on;
          }
        });
      }

      tabs.forEach(function (tab, idx) {
        tab.addEventListener('click', function () { select(idx); });
        tab.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = (idx + 1) % tabs.length;
          if (e.key === 'ArrowLeft') next = (idx - 1 + tabs.length) % tabs.length;
          if (next === null) return;
          e.preventDefault();
          select(next);
          tabs[next].focus();
        });
      });
    }

    function initDishes(root) {
      var list = root.querySelector('.pdet-dsel-list');
      if (!list || list.dataset.pdetReady) return;
      list.dataset.pdetReady = '1';
      var items = Array.prototype.slice.call(list.querySelectorAll('.pdet-dsel-item'));

      function select(i) {
        items.forEach(function (item, idx) {
          var pane = root.querySelector('#' + item.getAttribute('aria-controls'));
          var on = idx === i;
          item.classList.toggle('is-active', on);
          item.setAttribute('aria-selected', on ? 'true' : 'false');
          item.tabIndex = on ? 0 : -1;
          if (pane) pane.hidden = !on;
        });
      }

      // Phones get a single compact select instead of the full list; the list is the no-JS fallback.
      var wrap = root.querySelector('.pdet-dsel');
      var picker = null;
      if (wrap && items.length) {
        var pick = document.createElement('div');
        pick.className = 'pdet-dsel-pick';
        var label = document.createElement('label');
        label.className = 'pdet-dsel-picklabel';
        label.textContent = wrap.dataset.pickLabel || 'Gericht auswählen';
        picker = document.createElement('select');
        picker.className = 'pdet-dsel-select';
        picker.id = 'pdet-pick-' + (list.id || Math.random().toString(36).slice(2, 8));
        label.htmlFor = picker.id;
        items.forEach(function (item, i) {
          var opt = document.createElement('option');
          var name = item.querySelector('.pdet-dsel-name');
          var meta = item.querySelector('.pdet-dsel-meta');
          opt.value = String(i);
          opt.textContent = (name ? name.textContent.trim() : 'Gericht ' + (i + 1)) + (meta ? ' · ' + meta.textContent.trim() : '');
          picker.appendChild(opt);
        });
        picker.addEventListener('change', function () { select(parseInt(picker.value, 10) || 0); });
        pick.appendChild(label);
        pick.appendChild(picker);
        wrap.insertBefore(pick, wrap.firstChild);
        wrap.classList.add('has-select');
      }

      items.forEach(function (item, idx) {
        item.addEventListener('click', function () {
          select(idx);
          if (picker) picker.value = String(idx);
        });
        item.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowDown') next = (idx + 1) % items.length;
          if (e.key === 'ArrowUp') next = (idx - 1 + items.length) % items.length;
          if (e.key === 'Home') next = 0;
          if (e.key === 'End') next = items.length - 1;
          if (next === null) return;
          e.preventDefault();
          select(next);
          items[next].focus();
        });
      });
    }

    document.querySelectorAll('.pdet').forEach(function (root) { init(root); initDishes(root); });
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('.pdet').forEach(function (root) { init(root); initDishes(root); });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
